import {
    MIN_THUMBNAIL_WIDTH,
    MIN_THUMBNAIL_HEIGHT,
    MIN_THUMBNAIL_SIZE_VALIDATION_ERROR_MESSAGE_ID,
    THUMBNAIL_URL_LOAD_FAILED_ERROR_MESSAGE_ID,
    MIN_VERTICAL_THUMBNAIL_WIDTH,
    MIN_VERTICAL_THUMBNAIL_HEIGHT,
    MIN_VERTICAL_THUMBNAIL_SIZE_VALIDATION_ERROR_MESSAGE_ID,
    THUMBNAIL_RATIO_VALIDATION_ERROR_MESSAGE_ID,
    VERTICAL_THUMBNAIL_RATIO_VALIDATION_ERROR_MESSAGE_ID,
} from 'modules/campaigns/modules/creative-creator/config/thumbnailValidationConsts';
import { isFileTypeImage } from 'modules/campaigns/modules/creative-creator/services/utils';
import ValidationError from 'modules/errors/ValidationError';

const isValidDimensions = (dimensions, isVertical) => {
    if (isVertical) {
        return dimensions.width >= MIN_VERTICAL_THUMBNAIL_WIDTH && dimensions.height >= MIN_VERTICAL_THUMBNAIL_HEIGHT;
    }
    return dimensions.width >= MIN_THUMBNAIL_WIDTH && dimensions.height >= MIN_THUMBNAIL_HEIGHT;
};

const isValidRatio = (dimensions, isVertical) => {
    const { width, height } = dimensions;
    const ratio = width / height;

    return isVertical ? ratio < 1 : ratio >= 1;
};

export const validateFileDimensions = (file, isVertical) => {
    if (!isFileTypeImage(file.type)) {
        return;
    }

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (e) {
            const image = new Image();

            image.onload = function () {
                const dimensions = {
                    width: image.width,
                    height: image.height,
                };

                if (!isValidRatio(dimensions, isVertical)) {
                    reject(
                        new ValidationError(
                            'Thumbnail ratio validation failed',
                            isVertical
                                ? VERTICAL_THUMBNAIL_RATIO_VALIDATION_ERROR_MESSAGE_ID
                                : THUMBNAIL_RATIO_VALIDATION_ERROR_MESSAGE_ID
                        )
                    );
                }

                if (!isValidDimensions(dimensions, isVertical)) {
                    reject(
                        new ValidationError(
                            'Minimum thumbnail size validation failed',
                            isVertical
                                ? MIN_VERTICAL_THUMBNAIL_SIZE_VALIDATION_ERROR_MESSAGE_ID
                                : MIN_THUMBNAIL_SIZE_VALIDATION_ERROR_MESSAGE_ID
                        )
                    );
                }

                resolve(file);
            };

            image.src = e.target.result;
        };

        reader.onerror = () =>
            reject(new ValidationError('Image failed to load', THUMBNAIL_URL_LOAD_FAILED_ERROR_MESSAGE_ID));

        reader.readAsDataURL(file);
    });
};
